import { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import { CollapsibleCommentShell } from 'components/inspection/CollapsibleCommentShell';
import {
  TEMPLATE_COMMENT_FORMAT_TOOLBAR_TOGGLE_QA,
  isFloatingCommentLabel,
} from 'components/inspection/CollapsibleInspectionComment/model';
import { InspectionCommentLabelVariant } from 'components/inspection/CollapsibleInspectionComment/types';
import { resolveRichTextCommentLabel } from './model';
import type { CollapsibleRichTextCommentProps } from './types';

export function CollapsibleRichTextComment({
  value,
  disabled = false,
  labelVariant = InspectionCommentLabelVariant.section,
  floatingLabelId,
  children,
}: CollapsibleRichTextCommentProps): ReactElement {
  const intl = useIntl();
  const label = resolveRichTextCommentLabel(intl, floatingLabelId);

  return (
    <CollapsibleCommentShell
      value={value}
      label={label}
      locked={disabled}
      showFloatingLabel={isFloatingCommentLabel(labelVariant)}
      toggleDataQa={TEMPLATE_COMMENT_FORMAT_TOOLBAR_TOGGLE_QA}
    >
      {children}
    </CollapsibleCommentShell>
  );
}
